import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.widget.manual');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcuser-widget-manual',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.widget.manual/view.scss */
/* src/app/portal.gsdcuser.widget.manual/view.scss: no such file or directory */`],
})
export class PortalGsdcuserWidgetManualComponent implements OnInit {

    public manual: any = [];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load");
        if (code != 200) return;
        this.manual = data;
        await this.service.render();
    }
}

export default PortalGsdcuserWidgetManualComponent;